/**
 * Logo Component — MentionFox Design System v1.0
 * WHY: Centralised logo rendering with size + variant control
 * The logo image already includes the fox icon + "mentionfox" wordmark.
 */

import { cn } from "@/lib/utils";
import mentionfoxLogo from "@/assets/mentionfox-logo.png";

interface LogoProps {
  /** full = full logo image (icon + wordmark), icon = icon only (cropped via object-position) */
  variant?: "full" | "icon";
  size?: "sm" | "md" | "lg" | "xl";
  className?: string;
}

const sizeMap = {
  sm: "h-7",
  md: "h-9",
  lg: "h-11",
  xl: "h-14",
};

export function Logo({ variant = "full", size = "md", className }: LogoProps) {
  return (
    <img
      src={mentionfoxLogo}
      alt="MentionFox"
      className={cn("w-auto object-contain", sizeMap[size], className)}
    />
  );
}

